export interface GpsCoord {
  lat: number;
  lng: number;
  accuracy_m: number;
}

const cache = new Map<string, GpsCoord | null>();

/**
 * Get GPS for a job. First call requests permission and reads coords;
 * subsequent calls for the same jobId return the cached value (or null
 * if permission was denied).
 */
export async function getJobGps(jobId: string): Promise<GpsCoord | null> {
  if (cache.has(jobId)) return cache.get(jobId)!;
  if (!('geolocation' in navigator)) {
    cache.set(jobId, null);
    return null;
  }
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const coord: GpsCoord = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy_m: pos.coords.accuracy,
        };
        cache.set(jobId, coord);
        resolve(coord);
      },
      () => {
        cache.set(jobId, null);
        resolve(null);
      },
      { enableHighAccuracy: true, timeout: 10_000, maximumAge: 60_000 }
    );
  });
}

export function clearGpsCache(jobId?: string): void {
  if (jobId) cache.delete(jobId);
  else cache.clear();
}
